import {BadgeType} from '../../../graphql/generated/types';
import {IconType} from './IconType.enum';

/**
 * 뱃지 아이콘들이 상당수 제거되었기에 불필요한 BadgeType이 있는 지 확인해야 합니다.
 */
export const BADGE_TYPE_TO_ICON_TYPE_MAP: {
  [key in BadgeType]: IconType;
} = {
  [BadgeType.BadgeUpStatic]: IconType.BadgeUpStatic,
  [BadgeType.BadgeAge15Static]: IconType.Badge15Static,
  [BadgeType.BadgeAge18Static]: IconType.BadgeAdultStatic,
  [BadgeType.BadgeAge19Static]: IconType.Badge19Static,
  [BadgeType.BadgeEventStatic]: IconType.BadgeEventStatic,
  [BadgeType.BadgeLock]: IconType.BadgeLock,
  [BadgeType.BadgeNewStatic]: IconType.BadgeNewStatic,
  [BadgeType.BadgeRealFreeStatic]: IconType.BadgeFreeStatic,
  [BadgeType.BadgeUnlock]: IconType.BadgeUnlock,
  [BadgeType.BadgeWaitFreeStatic]: IconType.BadgeTimeStatic,
  [BadgeType.Badge0HourWaitfreeStatic]: IconType.Badge0HourStatic,
  [BadgeType.Badge1HourWaitfreeStatic]: IconType.Badge1HourStatic,
  [BadgeType.Badge2HourWaitfreeStatic]: IconType.Badge2HourStatic,
  [BadgeType.Badge3HourWaitfreeStatic]: IconType.Badge3HourStatic,
  [BadgeType.Badge3HourWaitfree]: IconType.ContentHome3Hour,
  [BadgeType.BadgeAge19CensorshipStatic]: IconType.Badge19SelfStatic,
  [BadgeType.BadgeNovelStatic]: IconType.BadgeNovelStatic,
};
